import React from 'react';
import { RecruitmentSection } from '../components/sections/RecruitmentSection';

const RecruitmentPage = () => {
  return (
    <div className="pt-32 sm:pt-40" data-testid="recruitment-page">
      <RecruitmentSection />
    </div>
  );
};

export default RecruitmentPage;
